"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.millisecondsToTimer = millisecondsToTimer;
exports.getUsageTrackerWithNamespaceMaybeUpdated = getUsageTrackerWithNamespaceMaybeUpdated;

var _I18n = _interopRequireDefault(require("I18n"));

var _tracking = require("FileManagerCore/utils/tracking");

function millisecondsToTimer(milliseconds) {
  if (!milliseconds) {
    return null;
  }

  if (milliseconds < 3600000) {
    return _I18n.default.moment.utc(milliseconds).format('mm:ss');
  }

  return _I18n.default.moment.utc(milliseconds).format('HH:mm:ss');
}

function getUsageTrackerOverwriteProperties(usageTracker) {
  return {
    properties: {
      namespace: 'file-picker',
      'in-app': usageTracker.config.properties ? usageTracker.config.properties.namespace : 'unknown',
      screen: 'picker'
    }
  };
}

function getUsageTrackerWithNamespaceMaybeUpdated(usageTracker) {
  return (0, _tracking.isCurrentUsageTracker)(usageTracker) ? usageTracker.clone(getUsageTrackerOverwriteProperties(usageTracker)) : usageTracker;
}